import React from "react";
import moment from "moment";
import { stripHtmlToText } from "../../../utils/sanitizeHtml";

const CircularListItem = ({ circular, active, onSelect, onViewRecipients }) => {
  return (
    <div
      className={`circular-list-item${active ? " active" : ""}`}
      onClick={() => onSelect(circular)}
    >
      <div className="circular-list-item-header">
        <span className="circular-list-item-title">{circular.circular_topic}</span>
        <span className="circular-list-item-time">
          {circular.created_at ? moment(circular.created_at).fromNow() : ""}
        </span>
      </div>

      <div className="circular-list-item-preview">
        {stripHtmlToText(circular.circular_desc)}
      </div>

      <div className="circular-list-item-footer">
        {circular.circular_no && (
          <span className="circular-list-item-no">No. {circular.circular_no}</span>
        )}
        <button
          type="button"
          className="circular-recipients-btn"
          onClick={(e) => {
            e.stopPropagation();
            onViewRecipients(circular);
          }}
        >
          View Classes
        </button>
      </div>
    </div>
  );
};

export default CircularListItem;
